var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("activator",null,null,{ on: on, attrs: attrs })]}}],null,true)},'v-menu',_vm.$attrs,false),_vm.$listeners),[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }